var a;(function(t){t.whatsApp="whatsApp",t.instagram="instagram",t.telegram="telegram"})(a||(a={}));export{a as SocialLinkAlias};
